import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InputLabel, Select } from '@components/Common';

const FilterColumn = styled.div``;

interface Props {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

const BilledFilterControlled: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options = [
    { value: true, label: t('billing.billed') },
    { value: false, label: t('billing.not_billed') },
  ];

  const selectedOption = options.find(i => i.value === value) || null;

  const handleChange = (option: { value: boolean } | null, actionMeta: { action: string }) => {
    onChange(actionMeta.action === 'clear' ? null : option?.value ?? null);
  };

  return (
    <FilterColumn className="column">
      <InputLabel htmlFor="billedFilter">{t('entry.isBilled')}</InputLabel>
      <Select
        name="billedFilter"
        isClearable={true}
        placeholder={t('all')}
        value={selectedOption}
        onChange={handleChange}
        options={options}
      />
    </FilterColumn>
  );
};

export default BilledFilterControlled;
